import { vrfAbi } from '@/abi'
import {
  useContractAddresses,
  useContractCreationBlock,
  useWeb3,
} from '@/hooks'
import { delay } from '@/utils'
import { encodeEventTopics, parseEventLogs } from 'viem'

const eventNames = [
  'SubscriptionCreated',
  'SubscriptionFunded',
  'SubscriptionConsumerAdded',
  'SubscriptionConsumerRemoved',
  'SubscriptionCanceled',
]

export const useVrfEvents = (subId) => {
  const blocks = useContractCreationBlock()
  const contracts = useContractAddresses()
  const { chain } = useWeb3()
  const vrfCreationBlock = blocks.vrf
  const baseUrl = chain.blockExplorers.default.apiUrl

  const getAllEvents = async () => {
    const allEvents = []

    for (let i = 0; i < eventNames.length; i++) {
      const eventName = eventNames[i]

      const topics = encodeEventTopics({
        abi: vrfAbi,
        eventName,
        args: { subId },
      })

      const topicsQueryParams = topics
        .map((topic, index) => topic && `topic${index}=${topic}`)
        .join('&')

      const topicsCondition = `topic0_1_opr=and`

      const response = await fetch(
        `${baseUrl}?module=logs&action=getLogs&fromBlock=${BigInt(
          vrfCreationBlock,
        )}&toBlock=latest&address=${
          contracts.vrf
        }&${topicsQueryParams}&${topicsCondition}`,
      )

      const data = await response.json()

      const parsedLogs = parseEventLogs({
        abi: vrfAbi,
        logs: data.result,
        eventName,
      })

      allEvents.push(parsedLogs)

      await delay(1000)
    }

    return { events: allEvents.flat() }
  }

  return {
    getAllEvents,
  }
}
